var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-next-button"},[_c('button',{attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('next')}}},[(_vm.loading)?_c('div',{staticClass:"lds-ripple"},[_c('div'),_vm._v(" "),_c('div')]):[_vm._v(_vm._s(_vm.label))]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }